import { Button, ButtonGroup, Flex, ScrollView } from "@aws-amplify/ui-react"
import type { OrganizationDto } from "@strtmn/sds/types"
import { getErrorMessage } from "@strtmn/strtmn"
import { I18n } from "aws-amplify/utils"
import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { listOrgs } from "../../api/OrgsApi"
import { LoadingErrorState, RoundedCard } from "../../components"
import OrgTable from "../../components/admin/OrgTable"
import SearchField from "../../components/maschinen-liste/SearchField"

export function AdminOrgs() {
  const [orgs, setOrgs] = useState<OrganizationDto[] | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | undefined>(undefined)
  const navigate = useNavigate()

  useEffect(() => {
    const loadOrgs = async () => {
      setLoading(true)
      setOrgs(null)
      setError(undefined)
      try {
        const _orgs = await listOrgs()
        setOrgs(_orgs || null)
      } catch (err) {
        console.log(
          "AO.loadOrgs: Caught an error:",
          JSON.stringify(err, null, 2)
        )
        setError(getErrorMessage(err))
      } finally {
        setLoading(false)
      }
    }
    loadOrgs()
  }, [])

  if (loading || error) {
    /** @todo add white text color */
    return (
      <LoadingErrorState
        isLoading={loading}
        loadingMessage={I18n.get("Lade Betriebe, bitte warten...")}
        isError={!!error}
        errorMessage={`${I18n.get("Fehler")}: ${I18n.get(error!)}`}
      />
    )
  }

  const loadedOrgs = orgs!

  function redirectToCreateOrg() {
    navigate("./new/")
  }

  return (
    <main className="p-8 pt-2">
      <Flex
        className="!mb-4"
        justifyContent="space-between"
        alignItems="center"
        alignContent="center"
      >
        <div className="page-heading">{I18n.get("Betriebe verwalten")}</div>
        <SearchField whiteBackground={true} />
      </Flex>

      <RoundedCard>
        <ScrollView
          width="100%"
          height="calc(100vh - 300px)" // or any desired height
          minHeight="200px"
        >
          <OrgTable orgs={loadedOrgs} />
        </ScrollView>

        <ButtonGroup size="small">
          <Button onClick={redirectToCreateOrg}>
            {I18n.get("Betrieb hinzufügen")}
          </Button>

          <Link to="..">
            <Button variation="link" size="small">
              {I18n.get("Zurück")}
            </Button>
          </Link>
        </ButtonGroup>
      </RoundedCard>
    </main>
  )
}
